export const FETCH_COUNTRY = 'FETCH_COUNTRY'
export const FETCH_INTEREST = 'FETCH_INTEREST'
export const FETCH_TRIPS = 'FETCH_TRIPS'
export const FETCH_SAVED_TRIPS = 'FETCH_SAVED_TRIPS'
export const FETCH_YOUR_TRIPS = 'FETCH_YOUR_TRIPS'
export const SET_YOUR_TRIPS = 'SET_YOUR_TRIPS'
export const MAKE_ACTION = 'MAKE_ACTION'
export const SEARCH_MEMBERS = 'SEARCH_MEMBERS'
export const SELECT_TRIP = 'SELECT_TRIP'
export const SET_INVOICE = 'SET_INVOICE'
export const SET_TRIP_PREFERENCES = 'SET_TRIP_PREFERENCES'
export const SET_CARDS = 'SET_CARDS'
export const DELETE_TRIP = 'DELETE_TRIP'
export const SET_ASSETS = 'SET_ASSETS'
export const SET_HIDE_LOCK_ROOM = 'SET_HIDE_LOCK_ROOM'
export const SET_LOADING = 'SET_LOADING'
